<script>
	import { onMount } from 'svelte'
	import { fade } from 'svelte/transition'
	import lozad from 'lozad'

	const { $: jQuery } = window

	let lazyLoadEls = jQuery('.lozad')

	export let showrooms

	let intro_content = showrooms.shift()['intro_content']

	let activeShowroom = showrooms[0]
	$: activeShowrooms = [activeShowroom]

	let granite_bg_2 = '/wp-content/uploads/2021/12/granite_bg_2.png'
	let granite_bg_3 = '/wp-content/uploads/2021/12/granite_bg_3.png'

	onMount(() => {
		lazyLoadEls = jQuery('.lozad')
		if (lazyLoadEls.length) {
			let observer = lozad()
			observer.observe()
		}
	})
</script>

<div class="granite-bg-2 lozad" data-background-image={granite_bg_2} />
<div class="granite-bg-3 lozad" data-background-image={granite_bg_3} />

<div class="showroom">

	<div class="showroom-image-wrap">
		<div class="blue-elem" />
		{#each activeShowrooms as item}
			<div
				class="showroom-image lozad"
				data-background-image={item.location_image}
				in:fade
				out:fade />
		{/each}
	</div>

	<div class="showroom-outer">
		<div class="showroom-wrap">
			{#if intro_content}
				<div class="showroom-intro-content">
					{@html intro_content}
				</div>
			{/if}
			{#each showrooms as item (item.location_title)}
				<a
					href={item.location_link}
					class="showroom-item"
					class:active={item === activeShowroom}
					on:mouseenter={() => (activeShowroom = item)}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						width="18px"
						height="23px">
						<path
							fill-rule="evenodd"
							fill="rgb(255, 255, 255)"
							d="M0.586,11.552 L10.185,22.171 L17.205,22.171 L7.605,11.552
							L17.205,0.752 L10.185,0.752 L0.586,11.552 Z" />
					</svg>
					<div>
						<p>{item.location_title}</p>
						<address>{item.location_address}</address>
					</div>
				</a>
			{/each}
		</div>

	</div>

</div>
